module.exports = __webpack_public_path__ + "static/media/Signup_Flow2.954c8162.png";